import React, { useState } from 'react';
import { Button, Card, Col, Row, Space } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import isObject from 'lodash/isObject';
import { RiArrowLeftLine } from 'react-icons/ri';
import urlPageLocalNotifications from '../../../../../../urls/urlPageLocalNotifications';
import IntlMessages from '../../../../../../layout/components/lang/IntlMessages';
import handleResponse from '../../../../../../lib/handleResponse';
import transformErrors from '../../../../../../lib/transformErrors';
import BreadCrumbs from '../../../../../../layout/components/breadcrumbs';
import FormCreateLocalNotification from '../../../../forms/FormCreateLocalNotification';
import { useCreateLocalNotificationMutation } from '../../../../api/localNotificationsApiSlice';



const PageCreateLocalNotification = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [ formErrors, setFormErrors ] = useState({});

  const [ createLocalNotification, { isLoading: isCreatingLocalNotification } ] = useCreateLocalNotificationMutation();

  const onSubmit = (data) => {
    createLocalNotification(data)
      .unwrap()
      .then(() => {
        handleResponse(
          'success',
          intl,
          'ui-general-created-successfully',
          [ () => navigate(urlPageLocalNotifications()) ],
        );
      })
      .catch((error) => {
        handleResponse(
          'error',
          intl,
          'ui-general-create-failed',
          [ () => {
            if (isObject(error?.data?.errors)) {
              const formikInitialErrors = transformErrors(error?.data?.errors);

              setFormErrors(formikInitialErrors);
            }
          } ],
          error,
        );
      });
  };

  return (
    <>
      <Row
        gutter={[ 32, 32 ]}
        justify="space-between"
        className="hp-mb-32"
        align="middle"
      >
        <BreadCrumbs
          breadCrumbParent={
            <Link to={urlPageLocalNotifications()}>
              <IntlMessages id='local-notifications-breadcrumbs' />
            </Link>
          }
          breadCrumbActive={<IntlMessages id='ui-general-create' />}
        />

        <Col md={12} span={24}>
          <Row
            gutter={[ 8, 8 ]}
            justify="end"
            align="middle"
          >
            <Col>
              <Space>
                <Link to={urlPageLocalNotifications()}>
                  <Button
                    type="primary"
                    className="hp-mr-sm-8"
                    ghost="true"
                    icon={<RiArrowLeftLine className="hp-mr-8" size={18} />}
                  >
                    <IntlMessages id='ui-general-back-to-list' />
                  </Button>
                </Link>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[ 32, 32 ]}>
        <Col span={24}>
          <Card className="hp-border-color-black-40 hp-card-6">
            <FormCreateLocalNotification
              initialErrors={formErrors}
              isSubmitting={isCreatingLocalNotification}
              onSubmit={onSubmit}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageCreateLocalNotification;
